// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as PostJobRouteImport } from './routes/post-job'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as ConfirmRouteImport } from './routes/confirm'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RemoteIndexRouteImport } from './routes/remote/index'
import { Route as ResourcesGuidesRouteImport } from './routes/resources/guides'
import { Route as RemoteSlugRouteImport } from './routes/remote/$slug'
import { Route as BrowseSlugRouteImport } from './routes/browse/$slug'

const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const PostJobRoute = PostJobRouteImport.update({
            id: '/post-job',path: '/post-job',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const LocationsRoute = LocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => rootRouteImport
          })
const ConfirmRoute = ConfirmRouteImport.update({
            id: '/confirm',path: '/confirm',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RemoteIndexRoute = RemoteIndexRouteImport.update({
            id: '/remote/',path: '/remote/',getParentRoute: () => rootRouteImport
          })
const ResourcesGuidesRoute = ResourcesGuidesRouteImport.update({
            id: '/resources/guides',path: '/resources/guides',getParentRoute: () => rootRouteImport
          })
const RemoteSlugRoute = RemoteSlugRouteImport.update({
            id: '/remote/$slug',path: '/remote/$slug',getParentRoute: () => rootRouteImport
          })
const BrowseSlugRoute = BrowseSlugRouteImport.update({
            id: '/browse/$slug',path: '/browse/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,ConfirmRoute: ConfirmRoute,LocationsRoute: LocationsRoute,NewsletterRoute: NewsletterRoute,PostJobRoute: PostJobRoute,SearchRoute: SearchRoute,BrowseSlugRoute: BrowseSlugRoute,RemoteSlugRoute: RemoteSlugRoute,ResourcesGuidesRoute: ResourcesGuidesRoute,RemoteIndexRoute: RemoteIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)